import vector from "images/vector.png";
import settings from "images/settings.png";
// import reportListing from "images/reportListing.png";
// import surveyListing from "images/surveyListing.png";
// import getStarted from "images/getStarted.png";
// import dashboardIcon from "images/dashboardIcon.png";
import getStarted from "images/navDrawerIcon/getStarted.png";
import dashboard from "images/navDrawerIcon/dashboard.png";
import esgMaturity from "images/navDrawerIcon/esgMaturity.png";
import esgStrategy from "images/navDrawerIcon/esgStrategy.png";
import esgCompliance from "images/navDrawerIcon/esgCompliance.png";
import dataHub from "images/navDrawerIcon/datahub.png";

import materialityMapping from "images/navDrawerIcon/materialityMapping.png";
import organisationalStructure from "images/navDrawerIcon/organisationStructure.png";
import survey from "images/navDrawerIcon/survey.png";
import supplier from "images/navDrawerIcon/supplier.png";
import task from "images/navDrawerIcon/task.png";

// Configuration array for the navigation items

const navItems = [
  {
    path: "/dashboard",
    icon: dashboard,
    label: "Dashboard",
    dataTut: "reactour__report_listing",
    // userType: ["ADMIN"],
    screen: "DASHBOARD",
    index: 2,
    disableStyle: true,
  },
  {
    path: "/organisational_structure",
    icon: organisationalStructure,
    label: "Organisational Structure",
    dataTut: "reactour__report_listing",
    // userType: ["ADMIN"],
    screen: "ORGANIZATION_STRUCTURE",
    index: 3,
    disableStyle: true,
  },
  {
    path: "/esg_maturity",
    icon: esgMaturity,
    label: "Maturity",
    dataTut: "reactour__report_listing",
    // userType: ["ADMIN"],
    screen: "ESG_MATURITY",
    index: 4,
    disableStyle: true,
  },
  {
    path: "/materiality_mapping",
    icon: materialityMapping,
    label: "Materiality",
    dataTut: "reactour__survery_listing",
    // userType: ["ADMIN"],
    screen: "MATERIALITY_MAPPING",
    index: 5,
    disableStyle: true,
  },
  {
    path: "/esg_strategy",
    icon: esgStrategy,
    label: "Strategy",
    dataTut: "reactour__survery_listing",
    // userType: ["ADMIN"],
    screen: "ESG_STRATEGY",
    index: 6,
    disableStyle: true,
  },

  {
    path: "/esg_compliance",
    icon: esgCompliance,
    label: "Reporting & Compliance",
    dataTut: "reactour__compliance_listing",
    // userType: ["ADMIN"],
    screen: "ESG_COMPLIANCE",
    index: 7,
    disableStyle: true,
  },
  {
    path: "/data_hub",
    icon: dataHub,
    label: "Data Hub",
    dataTut: "reactour__report_listing",
    // userType: ["ADMIN"],
    screen: "DATAHUB",
    index: 11,
    disableStyle: true,
  },
  {
    path: "/supplier",
    icon: supplier,
    label: "Supplier Assessment",
    dataTut: "reactour__supplier_listing",
    // userType: ["ADMIN"],
    screen: "SUPPLIER_ASSESSMENT",
    index: 8,
    disableStyle: true,
  },
  {
    path: "/survey",
    icon: survey,
    label: "Survey",
    dataTut: "reactour__supplier_admin_survery_listing",
    // userType: ["SUPPLIER_ADMIN"],
    screen: "SUPPLIER_SURVEY",
    index: 14,
    disableStyle: true,
  },
  {
    path: "/survey",
    icon: survey,
    label: "Survey",
    dataTut: "reactour__survery_listing",
    // userType: ["ADMIN"],
    screen: "SURVEY",
    index: 14,
    disableStyle: true,
  },
  {
    path: "/task",
    icon: task,
    label: "My Task",
    dataTut: "reactour__suplier_task_listing",
    // userType: ["ADMIN", "GENERAL"],
    screen: "MY_TASK",
    index: 9,
    disableStyle: true,
  },
  {
    path: "/get_started",
    icon: getStarted,
    label: "Get Started",
    dataTut: "reactour__get_started",
    // userType: ["ADMIN"], // Optional: restrict to specific user types
    screen: "GET_STARTED",
    index: 1,
    disableStyle: true,
  },
  {
    path: "/general_settings",
    icon: settings,
    label: "General Settings",
    dataTut: "reactour__general_settings",
    // userType: ["ADMIN", "SUPPLIER_GENERAL", "SUPPLIER_ADMIN"],
    screen: "GENERAL_SETTINGS",
    index: 12,
    disableStyle: false, // General settings should not have disabled style
  },
  {
    path: "/risk_admin",
    icon: supplier,
    label: "Risk",
    dataTut: "reactour__supplier_listing",
    // userType: ["RE"],
    screen: "RISK_ORGANIZATIONS",
    index: 8,
    disableStyle: true,
  },

  {
    path: "/task/supplier_task",
    icon: task,
    label: "Task",
    dataTut: "reactour__supplier_admin_task_listing",
    // userType: ["SUPPLIER_GENERAL", "SUPPLIER_ADMIN"],
    screen: "SUPPLIER_TASK",
    index: 9,
    disableStyle: true,
  },

  {
    path: "/framework",
    icon: survey,
    label: "Framework",
    dataTut: "reactour__framework",
    // userType: ["ADMIN"],
    screen: "FRAMEWORK",
    index: 15,
    disableStyle: true,
  },
  {
    path: "/sid",
    icon: getStarted,
    label: "SID",
    dataTut: "reactour__sid",
    // userType: ["ADMIN"],
    screen: "SID",
    index: 16,
    disableStyle: true,
  },
  // {
  //   path: "/auditor_task",
  //   icon: task,
  //   label: "Auditor Task",
  //   dataTut: "reactour__report_listing",
  //   screen: "AUDITOR_TASK",
  //   index: 13,
  //   disableStyle: true,
  // },
  // {
  //   path: "/survey_listing",
  //   icon: surveyListing,
  //   label: "Assessments",
  //   dataTut: "reactour__survery_listing",
  //   userType: ["SA"],
  //   index: 6,
  //   disableStyle: true,
  // },
  // {
  //   path: "/report_listing",
  //   icon: reportListing,
  //   label: "Tasks",
  //   dataTut: "reactour__report_listing",
  //   userType: ["A", "SA"],
  //   index: 3,
  //   disableStyle: true,
  // },
];

export default navItems;

//old nav items ,
// const navItems = [
//     {
//       path: "/get_started",
//       icon: getStarted,
//       label: "Get Started",
//       dataTut: "reactour__get_started",
//       userType: ["A", "SA"], // Optional: restrict to specific user types
//       index: 12,
//       disableStyle: true,

//     },
//     {
//       path: "/dashboard_static",
//       icon: dashboardIcon,
//       label: "Dashboard Static",
//       dataTut: "reactour__report_listing",
//       userType: ["A", "SA"],
//       index: 5,
//       disableStyle: true,

//     },
//     {
//       path: "/survey_listing",
//       icon: surveyListing,
//       label: "Assessments",
//       dataTut: "reactour__survery_listing",
//       userType: ["SA"],
//       index: 6,
//       disableStyle: true,

//     },
//     {
//       path: "/report_listing",
//       icon: reportListing,
//       label: "Tasks",
//       dataTut: "reactour__report_listing",
//       userType: ["A", "SA"],
//       index: 3,
//       disableStyle: true,

//     },
//     {
//       path: "/data_hub/sheets_import",
//       icon: vector,
//       label: "Data Hub",
//       dataTut: "reactour__report_listing",
//       userType: ["SA"],
//       index: 1,
//       disableStyle: true,
//     },
//     {
//       path: "/general_settings",
//       icon: settings,
//       label: "General Settings",
//       dataTut: "reactour__general_settings",
//       index: 8,
//       disableStyle: false, // General settings should not have disabled style
//     },
//   ];
